/**
 * API Configuration — Production
 *
 * Backend used by `npm run build` and the production build deployed to the prod S3 bucket.
 */

export const API_BASE_URL = 'https://terabase.services';

// Base URL for the Terrain Pro web app (different host than the API).
// Used to deep-link from the API docs into the app at /tools/terrainpro/project/{id}/layout/{id}.
export const TERRAIN_PRO_APP_BASE_URL = 'https://services.terabase.energy';
